// constants/tabs.ts

/**
 * Tab configuration for ThreatIntelDrawer
 */
export const THREAT_INTEL_TABS = [
  { label: 'Overview', value: '' },
  { label: 'Exploitation Timeline', value: 'exploitation-timeline' },
  { label: 'Frameworks', value: 'mitre' },
  { label: 'Assets Impacted', value: 'assets' },
] as const;

/**
 * CVSS metric group descriptions
 */
export const METRIC_GROUP_DESCRIPTIONS: Record<string, string> = {
  Base: 'Risk based on the characteristics of the vulnerability',
  Temporal: 'Risk based on the availability of patches and exploits',
  Threat: 'Risk based on the availability of patches and exploits',
};

/**
 * Preferred CVSS versions in order of preference
 */
export const PREFERRED_CVSS_VERSIONS = ['3.1', '3.0', '4', '2'];
